import { useDrawer } from "../../../hooks/useDrawer";
import type { IDrawerContent } from "../../../interfaces/drawer.interface";
import Tabs from "../../../../../shared/components/Tabs";
import WithdrawalFundsCrypto from "../components/WithdrawalFundsCrypto";
import WithdrawalFundsFiat from "../components/WithdrawalFundsFiat";

export function useWithdrawalDrawerRoute() {
  const { setActiveContent } = useDrawer();

  function showFundsDrawer() {
    setActiveContent(buildDrawerFundsHome());
  }

  function createWithdrawalFundsTabs() {
    return [
      {
        label: "Crypto",
        element: (
          <WithdrawalFundsCrypto
            onSubmit={() => {
              setActiveContent(null);
            }}
          />
        ),
      },
      {
        label: "Fiat",
        element: (
          <WithdrawalFundsFiat
            onSubmit={() => {
              setActiveContent(null);
            }}
          />
        ),
      },
    ];
  }

  function buildDrawerFundsHome(): IDrawerContent {
    return {
      title: "Withdrawal Funds",
      element: <Tabs tabs={createWithdrawalFundsTabs()} />,
    };
  }

  return {
    showFundsDrawer,
  };
}
